import React from 'react';

import { useNode } from '@craftjs/core';

import {
  FLEX_ORDER_OPTIONS,
  FLEX_JUSTIFY_CONTENT_OPTIONS,
  V_FLEX_ORDER_OPTIONS,
  FLEX_DIRECTION_OPTIONS,
  FLEX_ALIGN_OPTIONS,
} from '@common/constants';

import SettingsRow from '@common/components/SettingsWrapper/SettingsRow';
import AlignStyle from '@resolvers/tools/AlignStyle/AlignStyle';

const FlexAlignment = ({ hideElements = {} }) => {
  const { flexDirection } = useNode(({ data: { props } }) => {
    return {
      flexDirection: props.flexDirection,
    };
  });
  return (
    <>
      <SettingsRow>
        {!hideElements?.flexDirection && (
          <AlignStyle
            propKey='flexDirection'
            options={FLEX_DIRECTION_OPTIONS}
          />
        )}

        <AlignStyle
          propKey='flexOrder'
          options={
            flexDirection === 'column'
              ? V_FLEX_ORDER_OPTIONS
              : FLEX_ORDER_OPTIONS
          }
        />
      </SettingsRow>
      <SettingsRow>
        <AlignStyle propKey='alignItems' options={FLEX_ALIGN_OPTIONS} />
        <AlignStyle
          propKey='justifyContent'
          options={FLEX_JUSTIFY_CONTENT_OPTIONS}
        />
      </SettingsRow>
    </>
  );
};

export default FlexAlignment;
